<template>
  <div id="seleccion-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <v-card flat v-if="tabSelected == 'Cursos Regulares'">
                <dia-regular
                  :show="true"
                  :tipeView="'consulta'"
                  :contratoId="contratoId"
                ></dia-regular>
              </v-card>

              <v-card flat v-if="tabSelected == 'Cursos DS'">
                <dia-ds
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></dia-ds>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DiaRegular from "@/modules/configuration/reporteria/views/DiaRegular.vue";
import DiaDs from "@/modules/configuration/reporteria/views/DiaDs.vue";

export default {
  name: "dia-aplicacion-sub-tab",

  components: {
    DiaRegular,
    DiaDs,
  },
  props: {
    tabse: "",
  },
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Cursos Regulares", "Cursos DS"],
    contratoId: "",
    tabSelected: "",
    tabse: "",
    activeTab: 1,
    index: "",
    active_tab: "",
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;

    this.tab = "Cursos Regulares";

    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.tab;
    },
    selected(tab) {
      this.$store.commit("sub_tab_state", tab);
      this.tabSelected = tab;
    },
  },
};
</script>
